export * from './lib/data-table.module';

export * from './lib/components/data-table/data-table.component';

export * from './lib/interfaces/col-def.interface';
export * from './lib/interfaces/sort.interface';

export * from './lib/enums/sortorder.enum';

export * from './lib/functions/sort.function';
